Vendd.Scripts.load(function () {

    var languages = [];
    var current = undefined;

    var languageManager = function () {

    };

    languageManager.prototype.init = function (currentLanguageCode) {

        return Vendd.api.call(Vendd.api.path('admin', '/api/InlineAdmin/GetSiteLanguages'), {})
            .then(function (response) {

                languages = response;

                current = languages.find(function (x) { return x.TwoLetterCode === currentLanguageCode });

            });

    };

    Object.defineProperty(languageManager.prototype, "all", {
        get: function () {
            return JSON.parse(JSON.stringify(languages));
        }
    });

    Object.defineProperty(languageManager.prototype, "current", {
        get: function () {
            return current == undefined || current == null
                ? undefined
                : JSON.parse(JSON.stringify(current));
        }
    });

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.languageManager = new languageManager();

});